import React from 'react';

import { Switch, Route } from 'react-router-dom';
import Home from './page/home/Home';
import Navbar from './component/navbar/Navbar'
import './App.css'
import AboutPage from './page/About';
import Footer from './component/Footer';
import Projects from './page/Projects';
import Contacts from './page/Contacts';
import Dashboard from './page/admin/Dashboard';



const App = () => {
  const [showAdmin, setShowAdmin] = React.useState(false);
  React.useEffect(() => {
    if (window.location.href.toString().includes("/admin")) {
      setShowAdmin(true)
    }
  },[]);
  return (
    <>
    {
       showAdmin ?(
        <>
        
        <Switch>
        <Route exact path="/admin" component={Dashboard} />
        </Switch>

        </>
      ):(
        <>
        <Navbar/>
    <Switch>
      <Route exact path ="/" component={Home}/>
      <Route exact path ="/about" component={AboutPage}/>
      <Route exact path ="/projects" component={Projects}/>
      <Route exact path ="/contact" component={Contacts}/>
      
      
     
    </Switch>
    <Footer/>

        </>
      )
    }
   
    
     

    </>
  )
}

export default App;



